import { AccountMethods } from "../../const";

export const accountMethod = {
  type: "string",
  enum: Object.values(AccountMethods)
};
